import { render, staticRenderFns } from "./FollowNavTabs.vue?vue&type=template&id=46d58158&scoped=true&"
var script = {}
import style0 from "./FollowNavTabs.vue?vue&type=style&index=0&id=46d58158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d58158",
  null
  
)

export default component.exports